import { modals } from "@mantine/modals";
import { CourtFragment } from "../graphql";
import CourtForm from "../components/CourtForm";
import { track } from "../utils/analytics";

interface Args {
  onComplete: () => void | Promise<void>;
  onCancel?: () => void | Promise<void>;
}

function useCourtModal(args: Args) {
  const openCourtModal = (court?: CourtFragment) => {
    // FacilityMap is the only caller
    track("court_modal_opened", {
      mode: court ? "edit" : "create",
      source: "facility_map",
    });
    modals.open({
      title: court ? "Edit Court" : "Add Court",
      children: (
        <CourtForm
          cols={1}
          court={court}
          onSubmit={() => {
            args.onComplete();
            modals.closeAll();
          }}
        />
      ),
      onClose: args.onCancel,
    });
  };

  return { openCourtModal };
}

export default useCourtModal;
